import posthog from 'posthog-js';

export class PostHogService {
  static capture(eventName: string, properties?: Record<string, any>) {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.capture(eventName, {
        ...properties,
        timestamp: new Date().toISOString(),
        source: 'excel_addin'
      });
    }
  }

  static identify(userId: string, properties?: Record<string, any>) {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.identify(userId, properties);
    }
  }

  static setPersonProperties(properties: Record<string, any>) {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.setPersonProperties(properties);
    }
  }

  static trackPageView(pageName: string, properties?: Record<string, any>) {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.capture('$pageview', {
        $current_url: `office-addin://cicada/${pageName}`,
        page_name: pageName,
        ...properties
      });
    }
  }

  static trackBusinessEvent(eventType: 'connection' | 'disconnection' | 'api_call' | 'error' | 'user_action', details: Record<string, any>) {
    this.capture(`addin_${eventType}`, {
      event_category: 'business_logic',
      ...details
    });
  }

  static trackExcelOperation(operation: string, success: boolean, details?: Record<string, any>) {
    this.capture('excel_operation', {
      operation,
      success,
      event_category: 'excel_api',
      ...details
    });
  }

  static reset() {
    if (typeof window !== 'undefined' && posthog.__loaded) {
      posthog.reset();
    }
  }

  static isLoaded(): boolean {
    return typeof window !== 'undefined' && posthog.__loaded;
  }
}

export default PostHogService;
